<template>
  <div class="aboutus">
    <header-view :tabsign="9"></header-view>
    <div class="pic">关于我们</div>
    <div class="body w12 min-h">
      <div class="toptitle">
        <div class="left_c">
          <div class="redcon"></div>
          <span>关于我们</span>
        </div>
      </div>
      <div class="centent">
        <div class="lista">
          <div
            v-for="(item, index) in typelist"
            class="listsignle"
            @click="changetab(index)"
            :key="index"
          >
            <div :class="index == indexsign ? 'signlea_cur' : 'signlea'">
              <div>{{ item }}</div>
            </div>
            <div :class="index == indexsign ? '' : 'linecon'"></div>
          </div>
        </div>
        <div>
          <!-- <div class="title">简介</div>
          <div class="releasetime">发布时间：20121-08-17</div> -->
          <div v-html="msg" class="msg"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
	  msg:"",
      typelist: [
        "简介",
        "章程",
        "理事会",
        "我们的荣誉",
        "合作伙伴",
        "工作职能",
        "业务范围",
      ],
      supervisor: [{ name: "王华", office: "青海省希望工程指导服务中心主任" }],
      director: [{ name: "王华", office: "青海省希望工程指导服务中心主任" }],
      ambassador: [{ name: "王华", office: "青海省希望工程指导服务中心主任" }],
      indexsign: 0,
	  
	  
    };
  },
  
  mounted() {
	this.getConfig()  
  },
  
  methods: {
	regImg(val){
		var newContent = val.replace(/\<img/gi,'<img width="100%"');
		return newContent;
	},
	  
    changetab(index) {
        this.indexsign = index;
		this.getConfig()  
    },
	
	getConfig() {
		  var that = this;
		  var configId = "75"
		  if(this.indexsign == 0){
				configId = "75"
		  }else if(this.indexsign == 1){
		        configId = "76"
		  }else if(this.indexsign == 2){
				configId = "77"
		  }else if(this.indexsign == 3){
				configId = "78"
		  }else if(this.indexsign == 4){
				configId = "79"
		  }else if(this.indexsign == 5){
				configId = "80"
		  }else if(this.indexsign == 6){
				configId = "81"
		  }      
		  var param = {
				configId:configId,
		  };
		  this.httpGet("web/about/getConfig", param).then(res => {
			  if(res.success){
				    if(this.indexsign == 0 || this.indexsign == 4){
						that.msg = that.regImg(res.result)	
					}else{
						that.msg = res.result
					}			
			  }
		
		  });		  
	},
	
	
  },

  
};
</script>

<style scoped=" scoped" lang="scss">
.aboutus {
  position: relative;
  .pic {
    width: 100%;
    height: 400px;
    font-size: 75px;
    font-weight: 500;
    color: #e61f26;
    text-align: center;
    line-height: 400px;
    margin-top: 100px;
    background: url(../../assets/newimg/publicannounce_img.png) no-repeat top
      center/ 100% 100%;
  }
  .body {
    background: #ffffff;
    margin: 0px auto;
    .centent {
      margin: 20px auto;
      .lista {
        width: 100%;
        height:37px;
        background: #fbfbfb;
        display: flex;
        align-items: center;
        .listsignle {
          display: flex;
          align-items: center;
        }
        .signlea {
          width: 107px;
          height: 37px;
          line-height: 37px;
          text-align: center;
          color: #666666;
          font-size:16px;
		  cursor: pointer;
        }
        .signlea_cur {
          width: 107px;
          height: 37px;
          line-height:37px;
          text-align: center;
          background: #e70012;
          color: #ffffff;
          font-size:16px;
		  cursor: pointer;
        }
        .linecon {
          width: 1px;
          height: 17px;
          background: #666666;
          opacity: 0.3;
        }
      }
      .title {
        font-size:28px;
        font-weight: 400;
        color: #333333;
        line-height: 70px;
      }
      .releasetime {
        font-size: 14px;
        font-weight: 400;
        color: #666666;
      }
      .msg{
        margin: 40px 40px 20px 20px;
      }
      
    }

    .toptitle {
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left_c {
        display: flex;
        align-items: center;
        .redcon {
          width: 5px;
          height: 20px;
          background: #e70012;
          margin-right: 20px;
        }
        font-size:25px;
        font-weight: 400;
        color: #e61f26;
      }
      .right_c {
        .searchcon {
          height: 40px;
          line-height: 40px;
          border-radius: 15px;
          padding-left: 20px;
          padding-right: 20px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .inputa {
            width: 268px;
            height: 37px;
            font-size:14px;
            border: 1px solid #f1f1f1;
            border-radius: 15px;
            background: url(../../assets/searchimg.png) no-repeat;
            background-position: 230px 8px;
          }
          .imgcon {
            height:18px;
            width:18px;
          }
        }
      }
    }

  }
}
</style>
